/*
  SOLCOZM V3 — fondamenta JS (fase F1)

  SICUREZZA:
  - Agisce SOLO dentro contenitori con classe .sc-v3.
  - Se nella pagina non esiste nessun .sc-v3 non modifica il DOM, non
    registra listener di scroll/resize e non avvia animazioni.
  - Non tocca header, carrello, varianti o altri script del tema.
  - Con prefers-reduced-motion o senza IntersectionObserver mostra
    subito tutti i contenuti; un timer di sicurezza li mostra comunque.
*/
(function () {
  'use strict';

  // Ogni sezione V3 include questo script: va eseguito una sola volta per pagina.
  if (window.SolcozmV3Loaded) return;
  window.SolcozmV3Loaded = true;

  var ROOT_SELECTOR = '.sc-v3';
  var REVEAL_SELECTOR = '.sc-v3-reveal';
  var SAFETY_TIMEOUT_MS = 4000;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(root) {
    var items = root.querySelectorAll(REVEAL_SELECTOR);
    for (var i = 0; i < items.length; i++) items[i].classList.add('is-in');
  }

  function initRoot(root) {
    if (!root || root.__scV3Ready) return;
    root.__scV3Ready = true;

    var items = root.querySelectorAll(REVEAL_SELECTOR);
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      showAll(root);
      return;
    }

    root.classList.add('sc-v3-js');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });

    for (var i = 0; i < items.length; i++) observer.observe(items[i]);

    // Se le animazioni non partono (scheda in background, errori), i contenuti tornano visibili.
    window.setTimeout(function () { showAll(root); }, SAFETY_TIMEOUT_MS);
    root.__scV3Observer = observer;
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  function boot() {
    if (!document.querySelector(ROOT_SELECTOR)) return; // nessuna sezione V3: nessuna azione
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: inizializza le sezioni V3 aggiunte o ricaricate (non si attiva sul negozio pubblico).
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector(ROOT_SELECTOR)) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target ? event.target.querySelectorAll(ROOT_SELECTOR) : [];
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__scV3Observer) roots[i].__scV3Observer.disconnect();
    }
  });
})();
